import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDrawerToggleResult } from '@angular/material/sidenav';
import { AggregatedTaskListComponent } from 'app/modules/aggregated-tasks/aggregated-tasks-list/aggregated-tasks-list.component';

@Component({
  selector: 'aggregated-task-details',
  templateUrl: './aggregated-tasks-details.component.html',
})
export class AggregatedTaskDetailsComponent {
  closeDrawer(): Promise<MatDrawerToggleResult> {
    return this._aggregatedTasksListComponent.matDrawer.close();
  }

  commentViewFragment = AggregatedTaskDetailsComponent.commentViewFragment;

  static get commentViewFragment(): 'comment-view' {
    return 'comment-view';
  }

  constructor(private readonly _aggregatedTasksListComponent: AggregatedTaskListComponent) {}
  ngOnInit(): void {
    this._aggregatedTasksListComponent.matDrawer.open();
  }

  // ngAfterViewInit(): void {
  //   this._aggregatedTasksListComponent.matDrawer.openedChange
  //     .pipe(
  //       untilComponentDestroyed(this),
  //       filter((opened) => opened),
  //     )
  //     .subscribe(() => {
  //       this._titleField.nativeElement.focus();
  //     });

  //   this._activatedRoute.fragment
  //     .pipe(
  //       filter((fragment) => !!fragment),
  //       // this delay represents the time it takes for the drawer to open
  //       delay(500),
  //     )
  //     .subscribe((fragment) => {
  //       this.docRef.querySelector(`#${fragment}`)?.scrollIntoView({
  //         behavior: 'smooth',
  //         block: 'center',
  //         inline: 'start',
  //       });
  //     });
  // }
}
